import React from 'react';
import SolarPanel from './SolarPanel';
import Inverter from './Inverter';
import Meter from './Meter';
import ElectricalBox from './ElectricalBox';
import LTPanel from './LTPanel';
import PowerGrid2 from './PowerGrid2';
import ElectricityMeter from './ElectricityMeter';
import House from './House';
import { Text } from '@react-three/drei';

function ComponentBox({ component, onHover, onClick }) {
  const isLTPanel = component.name && component.name.startsWith('LT Panel');
  const isSolarPanel = component.name && component.name.includes('PV Array');
  const isInverter = component.name && component.name.includes('Inverter');
  const isSolarMeter = component.name && component.name.includes('Solar Meter');
  const isNetMeter = component.name && component.name.includes('Net Meter');
  const isDCBox = component.name && component.name.includes('DC Junction\nBox');
  const isACBox = component.name && component.name.includes('AC Box');
  const isLoToBox = component.name && component.name.includes('LoTo Box');
  const isELCB = component.name && component.name.includes('ELCB');
  const isGrid = component.name && component.name.includes('Grid & House Load');
  const isHouseLoad =
    component.name &&
    component.name.includes('House Load') &&
    !component.name.includes('Grid');

  if (isSolarPanel) {
    return (
      <SolarPanel
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
      />
    );
  }

  if (isInverter) {
    return (
      <Inverter
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
      />
    );
  }

  if (isSolarMeter) {
    return (
      <ElectricityMeter
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
        meterType='solar'
      />
    );
  }

  if (isNetMeter) {
    return (
      <ElectricityMeter
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
        meterType='net'
      />
    );
  }

  if (isDCBox) {
    return (
      <ElectricalBox
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
        boxType='dc'
      />
    );
  }

  if (isACBox) {
    return (
      <ElectricalBox
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
        boxType='ac'
      />
    );
  }

  if (isLoToBox) {
    return (
      <ElectricalBox
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
        boxType='lto'
      />
    );
  }

  if (isELCB) {
    return (
      <ElectricalBox
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
        boxType='elcb'
      />
    );
  }

  if (isLTPanel) {
    return (
      <LTPanel
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
      />
    );
  }

  if (isGrid) {
    return (
      <PowerGrid2
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
        type='grid'
      />
    );
  }

  if (isHouseLoad) {
    return (
      <House
        position={component.position}
        size={component.size}
        onHover={onHover}
        onClick={onClick}
        component={component}
        type='house'
      />
    );
  }

  // Fallback to original box for any unhandled components
  return (
    <group>
      <mesh
        position={component.position}
        onPointerOver={() => onHover(component.name)}
        onPointerOut={() => onHover(null)}
        onClick={() => onClick(component)}
        castShadow
        receiveShadow
      >
        <boxGeometry args={component.size} />
        <meshLambertMaterial color={component.color} />
      </mesh>
      <Text
        position={[
          component.position[0],
          component.position[1] + component.size[1] / 2 + 0.7,
          component.position[2],
        ]}
        fontSize={0.45}
        color='black'
        anchorX='center'
        anchorY='middle'
        outlineColor='#000000ff'
        outlineWidth={0.01}
        fontWeight={700}
      >
        {component.name}
      </Text>
    </group>
  );
}

export default ComponentBox;
